import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../../lib/api'
import { SessionRail } from '../../components/ui'
import type { Patient, ContinuityCase } from '../../lib/types'

type MyCase = ContinuityCase & { provider_name: string | null; next_session_at: string | null }

export default function PatientDashboard() {
  const [profile, setProfile] = useState<Patient | null>(null)
  const [activeCase, setActiveCase] = useState<MyCase | null>(null)
  const [loadingCase, setLoadingCase] = useState(true)

  useEffect(() => {
    api('/patients/me').then(setProfile)
    api('/patients/me/case').then(setActiveCase).finally(() => setLoadingCase(false))
  }, [])

  if (!profile || loadingCase) return <div className="page-loading">Loading…</div>

  return (
    <div>
      <div className="page-head">
        <h1>Welcome, {profile.name}</h1>
        <div className="ph-sub">{profile.email}</div>
      </div>

      {activeCase ? (
        <div className="card">
          <h3>Your care</h3>
          <p className="muted" style={{ fontSize: 13.5 }}>
            Matched with {activeCase.provider_name || 'your provider'} — status: {activeCase.status}
          </p>
          {activeCase.next_session_at && (
            <p className="muted" style={{ fontSize: 13.5 }}>
              Next session: {new Date(activeCase.next_session_at).toLocaleString(undefined, { weekday: 'long', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'UTC' })}
            </p>
          )}
          <SessionRail count={activeCase.session_count} />
        </div>
      ) : (
        <div className="card">
          <h3>You haven't selected a provider yet</h3>
          <p className="muted" style={{ fontSize: 13.5 }}>Complete your intake to see your routing matches.</p>
          <Link className="btn full" to="/patient/intake" style={{ marginTop: 10, display: 'block', textAlign: 'center' }}>Start intake</Link>
        </div>
      )}

      <p className="legal-note" style={{ marginTop: 20 }}>
        ATUUNE routes and tracks continuity of care — it is not an EHR, telehealth platform, or messaging
        service. Contact your provider directly for clinical questions.
      </p>
    </div>
  )
}
